import script from "./community-settings.vue?vue&type=script&lang=ts&setup=true"
export * from "./community-settings.vue?vue&type=script&lang=ts&setup=true"

import "./community-settings.vue?vue&type=style&index=0&id=c6c7e070&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3567651837/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6c7e070"]])

export default __exports__